import styled from 'styled-components'

export const StyleContainer = styled.div`
  width: 100%;
  max-width: 1000px;
  margin 0 auto;
  margin-top: 30px;
`
